import { Typography } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import React, { memo } from 'react';
import { CheckBoxSchemaProps } from './types';

type Props = CheckBoxSchemaProps;
const CheckBoxSchema = React.forwardRef<HTMLInputElement, Props>((props: Props, ref) => {
  const {
    required,
    formControlProps,
    error,
    value,
    label,
    labelPlacement = 'end',
    readOnly,
    disabled,
    checked,
    ...rest
  } = props;

  return (
    <FormControlLabel
      required={required}
      control={<Checkbox sx={{ padding: 0.4, ml: 1 }} checked={checked} inputRef={ref} {...rest} />}
      label={
        <Typography
          variant={labelPlacement === 'top' ? 'caption' : 'body2'}
          mb={labelPlacement === 'top' ? 1 : undefined}
        >
          {label}
        </Typography>
      }
      labelPlacement={labelPlacement}
      sx={{
        alignItems: labelPlacement === 'top' ? 'baseline' : undefined,
      }}
      disabled={disabled || readOnly}
      {...formControlProps}
    />
  );
});
export default memo(CheckBoxSchema);
